var CART_CHECKOUT_AGREEMENT_KEY = 'bb-cart-checkout-agreement-checked';

/**
 * @param {boolean} checked
 */
function setCartCheckoutAgreementChecked(checked) {
  if (checked) {
    sessionStorage.setItem(CART_CHECKOUT_AGREEMENT_KEY, 'true');
  } else {
    sessionStorage.removeItem(CART_CHECKOUT_AGREEMENT_KEY);
  }
}

/**
 * @returns {boolean}
 */
function isCartCheckoutAgreementChecked() {
  return sessionStorage.getItem(CART_CHECKOUT_AGREEMENT_KEY) === 'true';
}

/**
 * Syncs cart checkout button disabled/aria-disabled state with the agreement checkbox.
 *
 * @param {HTMLInputElement|null} checkbox
 * @param {HTMLButtonElement} button
 */
function updateCartCheckoutButton(checkbox, button) {
  if (!button) return;

  var enabled = !checkbox || checkbox.checked;

  if (enabled) {
    button.removeAttribute('disabled');
    button.setAttribute('aria-disabled', 'false');
  } else {
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
  }
}

/**
 * @param {Element} block - .cart-summary__checkout-block
 */
function syncCartCheckoutAgreementBlock(block) {
  var checkbox = block.querySelector('.cart-summary__checkout-checkbox');
  var button = block.querySelector('.cart-summary__checkout-button[name="checkout"]');

  if (!button) return;

  if (checkbox && isCartCheckoutAgreementChecked()) {
    checkbox.checked = true;
  }

  updateCartCheckoutButton(checkbox, button);
}

/**
 * @param {ParentNode} [root]
 */
function initCartCheckoutAgreement(root) {
  root = root || document;
  root.querySelectorAll('.cart-summary__checkout-block').forEach(syncCartCheckoutAgreementBlock);
}

function onCartCheckoutAgreementChange(event) {
  var checkbox = event.target;
  if (!checkbox.matches('.cart-summary__checkout-checkbox')) return;

  var block = checkbox.closest('.cart-summary__checkout-block');
  if (!block) return;

  setCartCheckoutAgreementChecked(checkbox.checked);
  syncCartCheckoutAgreementBlock(block);
}

function onCartSectionUpdate() {
  initCartCheckoutAgreement(document);
}

function bindCartCheckoutAgreementUpdates() {
  document.addEventListener('change', onCartCheckoutAgreementChange, false);

  document.addEventListener('DOMContentLoaded', onCartSectionUpdate);

  document.addEventListener('liquidAjaxCartInit', onCartSectionUpdate);
  document.addEventListener('liquid-ajax-cart:request-end', onCartSectionUpdate);
  document.addEventListener('liquid-ajax-cart:queue-end', onCartSectionUpdate);

  if (
    window.liquidAjaxCart &&
    typeof window.liquidAjaxCart.subscribeToCartSectionsUpdate === 'function'
  ) {
    window.liquidAjaxCart.subscribeToCartSectionsUpdate(onCartSectionUpdate);
  }

  if (
    window.liquidAjaxCart &&
    typeof window.liquidAjaxCart.subscribeToCartAjaxRequests === 'function'
  ) {
    window.liquidAjaxCart.subscribeToCartAjaxRequests(function (requestState, subscribeToResult) {
      subscribeToResult(function (state) {
        if (state.responseData && state.responseData.ok) {
          onCartSectionUpdate();
        }
      });
    });
  }
}

bindCartCheckoutAgreementUpdates();
onCartSectionUpdate();
